import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { prescreenEndpoints } from '@/modules/prescreen/constants';

interface SubmitPrescreenResultInput {
  candidateJobId: string;
  satisfactionScore: number;
}

export const useSubmitPrescreenResultMutation = () => {
  return useMutation({
    mutationFn: async ({
      candidateJobId,
      satisfactionScore,
    }: SubmitPrescreenResultInput) => {
      const { data } = await fetchClient.POST(prescreenEndpoints.result, {
        params: {
          path: {
            candidateJobId,
          },
        },
        body: {
          satisfactionScore,
        },
      });

      return data;
    },
  });
};
